import { useCallback, useEffect, useRef, useState, forwardRef, useImperativeHandle } from "react"
import { useHistory, useLocation } from 'react-router-dom'

import Grid from '@material-ui/core/Grid'
import ModeEditIcon from '@material-ui/icons/EditOutlined'
import AttachIcon from '@material-ui/icons/AttachFile'
import RestoreFromTrashIcon from '@material-ui/icons/RestoreFromTrash'
import ImportExportOutlinedIcon from '@material-ui/icons/ImportExportOutlined';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import RefreshIcon from "@material-ui/icons/Refresh"
import CardIcon from '@material-ui/icons/LibraryBooks'
import AddIcon from '@material-ui/icons/Add'
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn'
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutline'

import Filters from "@base/Filter"
import Table from '@base/Table'
import Loading from "@base/Loading/Loading";
import Select from '@base/Inputs/Select';
import File from "@base/Inputs/File"
import TextField from "@base/Inputs/Text"
import SelectOption from '@base/Inputs/Select'
import Boolean from '@base/Inputs/Boolean'
import CheckBox from "@base/Inputs/CheckBox/CheckBox"
import { ButtonSave } from "@base/Button/ButtonForm"
import ButtonPrimary from '@base/Button'
import Toast from '@base/Toast'
import Dialog from '@base/Dialog'
import DialogConfirm from '@base/Dialog/DialogConfirm'
import DialogCartaoLegivel from '@base/Dialog/Cartao/DialogCartaoLegivel';
import VisualizadorDeArquivo from '@base/VisualizadorDeArquivo';
import { montarLinkCorte } from '@base/VisualizadorDeArquivo/VisualizadorDeArquivo';
import { ASC, PAGE, SIZE, TOTAL_ELEMENTS, TOTAL_PAGES, verifyPagingAndSorting } from '@base/Table/Utils'

import EscolaService from "@services/EscolaService"

import AuthorizedFunction from '@security/AuthorizedFunction';

import { toDate } from "@helpers/DateHelper"
import { removePagingAndSorting } from '@helpers/PaginationHelper'
import { optionsDiscrepanciaEnum, optionsNotasEnum } from '@helpers/EnumHelper'

import Cartao from "@pages/Escola/Cartoes/componentes/Cartao"
import TratamentoNomeDialog from "@pages/TratamentoNomes/TratamentoNomeDialog"
import DescartarCartaoDialog from "@pages/TratamentoNomes/DescartarCartaoDialog"
import AtualizarStatusDialog from "@pages/Escola/Cartoes/componentes/AtualizarStatusDialog"
import TratamentoDataNascimentoDialog from "@pages/TratamentoDataNascimento/TratamentoDataNascimentoDialog";
import TratamentoCPFDialog from "@pages/TratamentoCPF/TratamentoCPFDialog";
import TransferirCartaoDialog from "@pages/Escola/Cartoes/componentes/TransferirCartaoDialog"
import ListagemTratamentosDialog from "@pages/Escola/Cartoes/componentes/ListagemTratamentosDialog";

import useCaixas from "@hooks/enums/useCaixas";
import useUfs from "@hooks/enums/useUfs";
import useStatusPendencia from "@hooks/enums/useStatusPendencia";
import useOrigens from "@hooks/enums/useOrigens";
import useStatusCartao from "@hooks/enums/useStatusCartao";
import useTratamentoNomeTiposPendencia from '@hooks/enums/useTratamentoNomeTiposPendencia';
import useTratamentoDataNascimentoTiposPendencia from '@hooks/enums/useTratamentoDataNascimentoTiposPendencia';
import useTratamentoCPFTiposPendencia from '@hooks/enums/useTratamentoCPFTiposPendencia';

function removeDuplicatas(f) {
  const uniqueFields = {};

  return f.filter(item => {
    if (uniqueFields[item.field])
      return false;

    uniqueFields[item.field] = true;
    return true;
  });
}

const verifyOrderBy = (orderBy) => orderBy === 'origem' ? 'objetoPostal.origem'
  : orderBy === 'nomeAluno' ? 'aluno.nome'
    : orderBy === 'sexo' ? 'aluno.sexo'
      : orderBy === 'anoEscolar' ? 'aluno.anoEscolar'
        : orderBy === 'turno' ? 'aluno.turno'
          : orderBy === 'numeroObjetoPostal' ? 'objetoPostal' : orderBy;

export const CartoesTableViewV2 = forwardRef((props, ref) => {
  const processo = props.processo;

  const toastRef = useRef(null);
  const history = useHistory();
  const { search } = useLocation();

  const listagemUF = useUfs(props.processo);
  const listagemCaixas = useCaixas(props.processo);
  const listagemTiposNome = useTratamentoNomeTiposPendencia();
  const listagemTiposDataNascimento = useTratamentoDataNascimentoTiposPendencia();
  const listagemTiposCPF = useTratamentoCPFTiposPendencia();
  const listagemStatus = useStatusCartao();
  const listagemOrigem = useOrigens();
  const listagemPendenciaStatus = useStatusPendencia();
  const listagemStatusTratamentoNome = listagemPendenciaStatus;
  const listagemStatusTratamentoNomeDuplicado = listagemPendenciaStatus;
  const listagemStatusTratamentoDataNascimento = listagemPendenciaStatus;
  const listagemStatusTratamentoCPF = listagemPendenciaStatus;

  const [cartoes, setCartoes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingDialog, setLoadingDialog] = useState(false);

  const [cartaoSelecionado, setCartaoSelecionado] = useState("");
  const [posicaoCartaoSelecionado, setPosicaoCartaoSelecionado] = useState(0);
  const [blob, setBlob] = useState();
  const [, setIlegivel] = useState(false);
  const [callback, setCallback] = useState(null);

  const [openDialogEdicao, setOpenDialogEdicao] = useState(false);
  const [isTratamentoNota, setIsTratamentoNota] = useState(false);

  const [openDialogTratamentoNome, setOpenDialogTratamentoNome] = useState(false);
  const [openDialogTratamentoDataNascimento, setOpenDialogTratamentoDataNascimento] = useState(false);
  const [openDialogTratamentoCPF, setOpenDialogTratamentoCPF] = useState(false);
  const [openDialogArquivo, setOpenDialogArquivo] = useState(false);
  const [openDialogDescartarCartao, setOpenDialogDescartarCartao] = useState(false);
  const [openDialogCartaoArquivoLegivel, setOpenDialogCartaoArquivoLegivel] = useState(false);
  const [openDialogRestaurarCartao, setOpenDialogRestaurarCartao] = useState(false);
  const [openDialogAtualizarStatus, setOpenDialogAtualizarStatus] = useState(false);
  const [openModalVisualizarArquivo, setOpenModalVisualizarArquivo] = useState(false);
  const [openDialogMoverCartaoParaCaixaDaEscola, setOpenDialogMoverCartaoParaCaixaDaEscola] = useState(false);
  const [openDialogListagemTratamentos, setOpenDialogListagemTratamentos] = useState(false);

  const [openDialogTransferirCartoes, setOpenDialogTransferirCartoes] = useState(false);
  const [listaDeCartoesMarcados, setListaDeCartoesMarcados] = useState({});

  const [openDialogSubstituicao, setOpenDialogSubstituicao] = useState(false);
  const [novoCodigoCartao, setNovoCodigoCartao] = useState("");

  const [page, setPage] = useState(PAGE);
  const [size, setSize] = useState(SIZE);
  const defaultOrderBy = props.defaultOrderBy ? verifyOrderBy(props.defaultOrderBy) : 'codigo';
  const [sort, setSort] = useState([{ orderBy: defaultOrderBy, order: ASC }]);
  const [totalElements, setTotalElements] = useState(TOTAL_ELEMENTS);
  const [totalPages, setTotalPages] = useState(TOTAL_PAGES);

  const [filtros, setFiltros] = useState([]);
  const [filtroAtivo, setFiltroAtivo] = useState(props.escola || props.nivel ? true : false);
  const [filtroOrigem, setFiltroOrigem] = useState("");
  const [filtroStatus, setFiltroStatus] = useState("");
  const [filtroNome, setFiltroNome] = useState("");
  const [filtroCodigo, setFiltroCodigo] = useState("");
  const [filtroCodigoInep, setFiltroCodigoInep] = useState("");
  const [filtroNivel, setFiltroNivel] = useState("");
  const [filtroCaixa, setFiltroCaixa] = useState("");
  const [filtroSomenteComTratamentoNome, setFiltroSomenteComTratamentoNome] = useState(false);
  const [filtroStatusTratamentoNome, setFiltroStatusTratamentoNome] = useState("");
  const [filtroSomenteComTratamentoNomeDuplicado, setFiltroSomenteComTratamentoNomeDuplicado] = useState(false);
  const [filtroStatusTratamentoNomeDuplicado, setFiltroStatusTratamentoNomeDuplicado] = useState("");
  const [filtroTipoTratamentoNome, setFiltroTipoTratamentoNome] = useState("");
  const [, setFiltroSomenteComTratamentoNota] = useState(false);
  const [filtroSomenteComTratamentoNotaPendente, setFiltroSomenteComTratamentoNotaPendente] = useState(false);
  const [filtroStatusTratamentoNota, setFiltroStatusTratamentoNota] = useState("");
  const [filtroTipoTratamentoNota, setFiltroTipoTratamentoNota] = useState("");
  const [filtroSomenteComTratamentoDataNascimento, setFiltroSomenteComTratamentoDataNascimento] = useState(false);
  const [filtroStatusTratamentoDataNascimento, setFiltroStatusTratamentoDataNascimento] = useState("");
  const [filtroTipoTratamentoDataNascimento, setFiltroTipoTratamentoDataNascimento] = useState("");
  const [filtroSomenteComTratamentoCPF, setFiltroSomenteComTratamentoCPF] = useState(false);
  const [filtroStatusTratamentoCPF, setFiltroStatusTratamentoCPF] = useState("");
  const [filtroTipoTratamentoCPF, setFiltroTipoTratamentoCPF] = useState("");
  const [filtroTipoIlegibilidade, setFiltroTipoIlegibilidade] = useState("");
  const [filtroDiscrepancia, setFiltroDiscrepancia] = useState("");
  const [filtroNota, setFiltroNota] = useState("");
  const [filtroNotaCalculada, setFiltroNotaCalculada] = useState("");
  const [filtroDuplicidade, setFiltroDuplicidade] = useState("");
  const [filtroObjetoPostal, setFiltroObjetoPostal] = useState("");
  const [, setFiltroComEscolaAssociada] = useState("");
  const [filtroUF, setFiltroUF] = useState("");
  const [, setFiltroCartaoEmCaixaDiferenteDaEscola] = useState('');
  const [filtroMarcadoComoIlegivel, setFiltroMarcadoComoIlegivel] = useState("");
  const [filtroMarcadoComoLegivel, setFiltroMarcadoComoLegivel] = useState("");
  const [filtroDigitado, setFiltroDigitado] = useState("");
  const [filtroEmailDigitado, setFiltroEmailDigitado] = useState("");
  const [filtroEtiquetado, setFiltroEtiquetado] = useState("");
  const [filtroDigitadoMarcacoes, setFiltroDigitadoMarcacoes] = useState("");
  const [filtroLidoPeloOCRTexto, setFiltroLidoPeloOCRTexto] = useState("");
  const [filtroLidoPeloOCR, setFiltroLidoPeloOCR] = useState("");
  const [filtroCortado, setFiltroCortado] = useState("");
  const [filtroSomenteValidos, setFiltroSomenteValidos] = useState("");
  const [filtroSomenteCartoesEmProcessamento, setFiltroSomenteCartoesEmProcessamento] = useState("");
  const [filtroSomenteComDivergenciaNotaSemDigitador, setFiltroSomenteComDivergenciaNotaSemDigitador] = useState("");
  const [filtroParticipaSegundaFase, setFiltroParticipaSegundaFase] = useState("");
  const [filtroDtNasc, setFiltroDtNasc] = useState("");
  const [quantidadeFiltrosAplicados, setQuantidadeFiltrosAplicados] = useState(0);

  useImperativeHandle(ref, () => ({
    atualizarFiltrosQuantitativosNome(tipo, status) {
      limparCampos();
      setFiltroTipoTratamentoNome(tipo);
      setFiltroStatusTratamentoNome(status);
      setCallback(true);
    },

    atualizarFiltrosQuantitativosNomeDuplicado(status) {
      limparCampos();
      setFiltroStatusTratamentoNomeDuplicado(status);
      setCallback(true);
    },

    atualizarFiltrosQuantitativosDataNascimento(tipo, status) {
      limparCampos();
      setFiltroTipoTratamentoDataNascimento(tipo);
      setFiltroStatusTratamentoDataNascimento(status);
      setCallback(true);
    },

    atualizarFiltrosQuantitativosCPF(tipo, status) {
      limparCampos();
      setFiltroTipoTratamentoCPF(tipo);
      setFiltroStatusTratamentoCPF(status);
      setCallback(true);
    },
  }));

  const setters = useCallback(() => {
    return {
      origem: setFiltroOrigem,
      status: setFiltroStatus,
      nome: setFiltroNome,
      codigo: setFiltroCodigo,
      inep: setFiltroCodigoInep,
      nivel: setFiltroNivel,
      caixa: setFiltroCaixa,
      somenteComTratamentoNome: setFiltroSomenteComTratamentoNome,
      statusTratamentoNome: setFiltroStatusTratamentoNome,
      tipoPendenciaTratamentoNome: setFiltroTipoTratamentoNome,
      tipoIlegibilidade: setFiltroTipoIlegibilidade,
      somenteComTratamentoNomeDuplicado: setFiltroSomenteComTratamentoNomeDuplicado,
      statusTratamentoNomeDuplicado: setFiltroStatusTratamentoNomeDuplicado,
      somenteComTratamentoNotaPendente: setFiltroSomenteComTratamentoNotaPendente,
      statusTratamentoNota: setFiltroStatusTratamentoNota,
      tipoPendenciaTratamentoNota: setFiltroTipoTratamentoNota,
      somenteComTratamentoDataNascimento: setFiltroSomenteComTratamentoDataNascimento,
      statusTratamentoDataNascimento: setFiltroStatusTratamentoDataNascimento,
      tipoPendenciaTratamentoDataNascimento: setFiltroTipoTratamentoDataNascimento,
      somenteComTratamentoCPF: setFiltroSomenteComTratamentoCPF,
      statusTratamentoCPF: setFiltroStatusTratamentoCPF,
      tipoPendenciaTratamentoCPF: setFiltroTipoTratamentoCPF,
      discrepancia: setFiltroDiscrepancia,
      nota: setFiltroNota,
      notaCalculada: setFiltroNotaCalculada,
      dataNascimento: setFiltroDtNasc,
      comDuplicidade: setFiltroDuplicidade,
      objetoPostal: setFiltroObjetoPostal,
      uf: setFiltroUF,
      ilegivel: setFiltroMarcadoComoIlegivel,
      legivel: setFiltroMarcadoComoLegivel,
      digitado: setFiltroDigitado,
      emailDigitado: setFiltroEmailDigitado,
      etiquetado: setFiltroEtiquetado,
      digitadoMarcacoes: setFiltroDigitadoMarcacoes,
      lidoPeloOCRTexto: setFiltroLidoPeloOCRTexto,
      lidoPeloOCR: setFiltroLidoPeloOCR,
      cortado: setFiltroCortado,
      valido: setFiltroSomenteValidos,
      emprocessamento: setFiltroSomenteCartoesEmProcessamento,
      somenteComDivergenciaNotaSemDigitador: setFiltroSomenteComDivergenciaNotaSemDigitador,
      participaSegundaFase: setFiltroParticipaSegundaFase
    }}, []);

  const aplicarFiltros = useCallback((ativo = false) => {
    let f = [];

    if (filtroOrigem) f.push({ field: 'origem', value: filtroOrigem });
    if (filtroStatus) f.push({ field: 'status', value: filtroStatus });
    if (filtroNome) f.push({ field: 'nome', value: filtroNome });
    if (filtroCodigo) f.push({ field: 'codigo', value: filtroCodigo });
    if (filtroCodigoInep) f.push({ field: 'inep', value: filtroCodigoInep });
    if (filtroNivel) f.push({ field: 'nivel', value: filtroNivel });
    if (filtroCaixa) f.push({ field: 'caixa', value: filtroCaixa });
    if (filtroSomenteComTratamentoNome) f.push({ field: 'somenteComTratamentoNome', value: filtroSomenteComTratamentoNome });
    if (filtroStatusTratamentoNome) f.push({ field: 'statusTratamentoNome', value: filtroStatusTratamentoNome });
    if (filtroTipoTratamentoNome) f.push({ field: 'tipoPendenciaTratamentoNome', value: filtroTipoTratamentoNome });
    if (filtroTipoIlegibilidade) f.push({ field: 'tipoIlegibilidade', value: filtroTipoIlegibilidade });
    if (filtroSomenteComTratamentoNomeDuplicado) f.push({ field: 'somenteComTratamentoNomeDuplicado', value: filtroSomenteComTratamentoNomeDuplicado });
    if (filtroStatusTratamentoNomeDuplicado) f.push({ field: 'statusTratamentoNomeDuplicado', value: filtroStatusTratamentoNomeDuplicado });
    if (!filtroStatusTratamentoNota && filtroSomenteComTratamentoNotaPendente) f.push({ field: 'somenteComTratamentoNotaPendente', value: filtroSomenteComTratamentoNotaPendente });
    if (filtroStatusTratamentoNota) f.push({ field: 'statusTratamentoNota', value: filtroStatusTratamentoNota });
    if (filtroTipoTratamentoNota) f.push({ field: 'tipoPendenciaTratamentoNota', value: filtroTipoTratamentoNota });
    if (filtroSomenteComTratamentoDataNascimento) f.push({ field: 'somenteComTratamentoDataNascimento', value: filtroSomenteComTratamentoDataNascimento });
    if (filtroStatusTratamentoDataNascimento) f.push({ field: 'statusTratamentoDataNascimento', value: filtroStatusTratamentoDataNascimento });
    if (filtroTipoTratamentoDataNascimento) f.push({ field: 'tipoPendenciaTratamentoDataNascimento', value: filtroTipoTratamentoDataNascimento });
    if (filtroSomenteComTratamentoCPF) f.push({ field: 'somenteComTratamentoCpf', value: filtroSomenteComTratamentoCPF });
    if (filtroStatusTratamentoCPF) f.push({ field: 'statusTratamentoCpf', value: filtroStatusTratamentoCPF });
    if (filtroTipoTratamentoCPF) f.push({ field: 'tipoPendenciaTratamentoCpf', value: filtroTipoTratamentoCPF });
    if (filtroDiscrepancia) f.push({ field: 'discrepancia', value: filtroDiscrepancia });
    if (filtroNota) f.push({ field: 'nota', value: filtroNota });
    if (filtroNotaCalculada) f.push({ field: 'notaCalculada', value: filtroNotaCalculada });
    if (filtroDtNasc) f.push({ field: 'dataNascimento', value: toDate(filtroDtNasc) });
    if (filtroDuplicidade) f.push({ field: 'comDuplicidade', value: filtroDuplicidade });
    if (filtroObjetoPostal) f.push({ field: 'objetoPostal', value: filtroObjetoPostal });
    if (filtroUF) f.push({ field: 'uf', value: filtroUF });
    if (filtroMarcadoComoIlegivel) f.push({ field: 'ilegivel', value: filtroMarcadoComoIlegivel });
    if (filtroMarcadoComoLegivel) f.push({ field: 'legivel', value: filtroMarcadoComoLegivel });
    if (filtroDigitado) f.push({ field: 'digitado', value: filtroDigitado });
    if (filtroEmailDigitado) f.push({ field: 'emailDigitado', value: filtroEmailDigitado });
    if (filtroEtiquetado) f.push({ field: 'etiquetado', value: filtroEtiquetado });
    if (filtroDigitadoMarcacoes) f.push({ field: 'digitadoMarcacoes', value: filtroDigitadoMarcacoes });
    if (filtroLidoPeloOCRTexto) f.push({ field: 'lidoPeloOCRTexto', value: filtroLidoPeloOCRTexto });
    if (filtroLidoPeloOCR) f.push({ field: 'lidoPeloOCR', value: filtroLidoPeloOCR });
    if (filtroCortado) f.push({ field: 'cortado', value: filtroCortado });
    if (filtroSomenteValidos) f.push({ field: 'valido', value: filtroSomenteValidos });
    if (filtroSomenteCartoesEmProcessamento) f.push({ field: 'emprocessamento', value: filtroSomenteCartoesEmProcessamento });
    if (filtroSomenteComDivergenciaNotaSemDigitador) f.push({ field: 'somenteComDivergenciaNotaSemDigitador', value: filtroSomenteComDivergenciaNotaSemDigitador });
    if (filtroParticipaSegundaFase) f.push({ field: 'participaSegundaFase', value: filtroParticipaSegundaFase });

    if (props.sessionStorage)
      sessionStorage.setItem(props.sessionStorage, JSON.stringify(f));

    setFiltros(f);
    setFiltroAtivo(ativo);
    setQuantidadeFiltrosAplicados(f.filter(f =>
      f.field !== "somenteComTratamentoNome" ||
      f.field !== "somenteComTratamentoNomeDuplicado" ||
      f.field !== "somenteComTratamentoNota" ||
      f.field !== "somenteComTratamentoDataNascimento" ||
      f.field !== "somenteComTratamentoCPF"
    ).length)

    if (props.aoFiltrar)
      props.aoFiltrar();
  }, [props, filtroOrigem, filtroStatus, filtroNome, filtroCodigo, filtroCodigoInep, filtroNivel, filtroCaixa, 
    filtroSomenteComTratamentoNome, filtroStatusTratamentoNome, filtroTipoTratamentoNome, filtroTipoIlegibilidade, 
    filtroSomenteComTratamentoNomeDuplicado, filtroStatusTratamentoNomeDuplicado, filtroSomenteComTratamentoNotaPendente, 
    filtroStatusTratamentoNota, filtroTipoTratamentoNota, filtroSomenteComTratamentoDataNascimento, filtroStatusTratamentoDataNascimento, filtroTipoTratamentoDataNascimento, 
    filtroDiscrepancia, filtroNota, filtroNotaCalculada, filtroDtNasc, filtroDuplicidade, filtroObjetoPostal, filtroUF, filtroMarcadoComoIlegivel, filtroMarcadoComoLegivel, 
    filtroDigitado, filtroEmailDigitado, filtroEtiquetado, filtroDigitadoMarcacoes, filtroLidoPeloOCRTexto, filtroLidoPeloOCR, filtroCortado, filtroSomenteValidos, 
    filtroSomenteCartoesEmProcessamento, filtroSomenteComDivergenciaNotaSemDigitador, filtroParticipaSegundaFase,
    filtroSomenteComTratamentoCPF, filtroStatusTratamentoCPF, filtroTipoTratamentoCPF
  ]);

  const columns = props.colunas ? props.colunas : [
    { label: '', name: 'id', func: null, key: false, item: 'checkbox' },
    { label: 'id', name: 'id', key: true, hidden: true, },
    {
      label: 'Código', name: 'codigo', key: false, func: (c, l) => {
        let codigo = <span style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => visualizarArquivo(l.id)}>{c}</span>

        if (props.exibeInfoDigitacao === undefined || props.exibeInfoDigitacao === true) {
          if ((l.dataCorteImagens === undefined || !l.dataCorteImagens) && l.status !== "DESCARTADO") {
            codigo = <>{codigo} <span style={{
              padding: 2,
              borderRadius: 4,
              backgroundColor: "#3fb8ba",
              color: "white",
              display: 'inline-block',
              fontSize: 10
            }}><center>Aguardando Corte</center></span></>
          } 

          if ((l.dataLeituraTexto === undefined || !l.dataLeituraTexto) && l.status !== "DESCARTADO" && (l.dataDigitacaoTexto === undefined || !l.dataDigitacaoTexto)) {
            codigo = <>{codigo} <span style={{
              padding: 2,
              borderRadius: 4,
              backgroundColor: "#87b3c9",
              color: "white",
              display: 'inline-block',
              fontSize: 10
            }}><center>Aguardando Leitura de Textos</center></span></>
          } else if ((l.dataDigitacaoEmail === undefined || !l.dataDigitacaoEmail) && l.status !== "DESCARTADO") {
            codigo = <>{codigo} <span style={{
              padding: 2,
              borderRadius: 4,
              backgroundColor: "#3fb8ba",
              color: "white",
              display: 'inline-block',
              fontSize: 10
            }}><center>Aguardando Digitação de Email</center></span></>
          }

          if ((l.dataLeituraOCR === undefined || !l.dataLeituraOCR) && l.status !== "DESCARTADO" && (l.dataDigitacaoBolinha === undefined || !l.dataDigitacaoBolinha)) {
            codigo = <>{codigo} <span style={{
              padding: 2,
              borderRadius: 4,
              backgroundColor: "#87b3c9",
              color: "white",
              display: 'inline-block',
              fontSize: 10
            }}><center>Aguardando Leitura de Marcações</center></span></>
          }

          if ((l.dataDigitacaoTexto === undefined || !l.dataDigitacaoTexto) && l.status !== "DESCARTADO" && l.liberadoParaDigitacaoDeTexto) {
            codigo = <>{codigo} <span style={{
              padding: 2,
              borderRadius: 4,
              backgroundColor: "#3fb8ba",
              color: "white",
              display: 'inline-block',
              fontSize: 10
            }}><center>Aguardando Digitação de Texto</center></span></>
          }

          if ((l.dataDigitacaoBolinha === undefined || !l.dataDigitacaoBolinha) && l.status !== "DESCARTADO" && l.liberadoParaDigitacaoDeMarcacao) {
            codigo = <>{codigo} <span style={{
              padding: 2,
              borderRadius: 4,
              backgroundColor: "#3fb8ba", //"#bfad34",
              color: "white",
              display: 'inline-block',
              fontSize: 10
            }}><center>Aguardando Digitação de Marcações</center></span></>
          }

          if (l.status === "SEM_PENDENCIA") {
            codigo = <>{codigo} <span 
            title={`Cartão Sem Pendências`}
            style={{
              padding: 5,
              borderRadius: 20,
              backgroundColor: "#3dc461",
              color: "white",
              display: 'inline-block',
              fontSize: 10
            }}><center> </center></span></>
          } else if ((l.status === "COM_PENDENCIA_CONTEUDO" && !l.liberadoParaDigitacaoDeMarcacao) || l.status === "COM_PENDENCIA_NOME_DUPLICADO") {
            codigo = <>{codigo} <span 
              onClick={() => {
                setCartaoSelecionado(cartoes.find(c => c.id === l.id));
                setPosicaoCartaoSelecionado(cartoes.findIndex(c => c.id === l.id));
                setOpenDialogListagemTratamentos(true);
              }}
              title={`Ver Listagem de Tratamentos para o Cartão ${l.codigo}`}
              style={{
                padding: 5,
                borderRadius: 20,
                backgroundColor: "#fcc203",
                color: "white",
                display: 'inline-block',
                fontSize: 10,
                cursor: "pointer"
            }}><center> </center></span></>
          } else if (l.status === "AGUARDANDO_VERIFICACAO_PENDENCIA") {
            codigo = <>{codigo} <span 
            title={`Cartão Aguardando Verificação de Pendências`}
            style={{
              padding: 5,
              borderRadius: 20,
              backgroundColor: "#03dbfc",
              color: "white",
              display: 'inline-block',
              fontSize: 10
            }}><center> </center></span></>
          }
        }

        if (l.substituido) {
          codigo = <>{codigo}<span title={"Este cartão foi substituído, código substituto: " + l.codigoSubstituto}
            style={{
              padding: 5,
              backgroundColor: "#d9746c",
              borderRadius: 20,
              color: "white"
            }}>S</span></>;

        } else if (l.codigoOriginal !== l.codigo) {
          codigo = <>{codigo}<span
            title={`Código criado atráves de uma transferência, código original: ` + l.codigoOriginal}
            style={{
              padding: 5,
              backgroundColor: "#e8be84",
              borderRadius: 20,
              color: "white"
            }}>T</span></>;
        }

        return codigo;
      }
    },
    {
      label: 'Origem', name: 'origem', filter: 'objetoPostal.origem', key: false,
      func: (c, l) => (c === null) ? `` : <>{c.descricao} {(c.descricao === "Aplicativo" && l.statusEnvioGrafica === undefined ? "" : (l.statusEnvioGrafica === "ERRO" ?
        <span style={{ color: "#ed5f39", display: "block", fontSize: 10 }}>Falha na Transmissão para Gráfica</span> : ""))}</>
    },
  ];

  if (props.colunasAdicionais)
    props.colunasAdicionais.forEach(col => columns.push(col));

  const abrirModalEdicao = (id) => {
    setCartaoSelecionado(cartoes.find(c => c.id === id));
    setPosicaoCartaoSelecionado(cartoes.findIndex(c => c.id === id));
    setOpenDialogEdicao(true);
  }
  const abrirModalTratamentoNota = (id) => {
    setIsTratamentoNota(true)
    setCartaoSelecionado(cartoes.find(c => c.id === id));
    setPosicaoCartaoSelecionado(cartoes.findIndex(c => c.id === id));
    setOpenDialogEdicao(true);
  }

  const abrirModalTransferirCartao = () => {
    if (Object.keys(listaDeCartoesMarcados).length !== 0)
      setOpenDialogTransferirCartoes(true);
    else
      toastRef.current.show("warning", "Nenhum cartão foi selecionada para fazer a transferência.");
  }

  const handleTransferirCartao = (obj) => {
    setListaDeCartoesMarcados({
      codigoInep: obj.codigoInep,
      escolaNome: obj.escola,
      cartoes: [{ id: obj.id, nivel: obj.nivel, codigo: obj.codigo, legivel: obj.arquivoLegivel === undefined || obj.arquivoLegivel === true }]
    });

    setOpenDialogTransferirCartoes(true);
  }

  const abrirModalUploadArquivo = (id) => {
    setCartaoSelecionado(cartoes.find(c => c.id === id));
    setPosicaoCartaoSelecionado(cartoes.findIndex(c => c.id === id));
    setOpenDialogArquivo(true);
  }

  const abrirModalSubstituicao = (id) => {
    setCartaoSelecionado(cartoes.find(c => c.id === id));
    setPosicaoCartaoSelecionado(cartoes.findIndex(c => c.id === id));
    setOpenDialogSubstituicao(true);
  }

  const redirectDigitarCartoes = () => history.push("/" + processo + "/digitarCartoes");

  const submitSubstituicaoCartao = (id) => {
    EscolaService.substituirCartao(processo, filtroCodigoInep === "" || filtroCodigoInep === undefined ? cartaoSelecionado.codigo.substr(2, 8) : filtroCodigoInep, cartaoSelecionado.id, {
      "idCartaoAtual": cartaoSelecionado.id,
      "codigoCartaoSubstituto": novoCodigoCartao
    }).then(resultado => {
      setFiltroAtivo(true);
      setOpenDialogSubstituicao(false);
      buscarCartoes();
    }).catch(resultado => {
      toastRef.current.show("error", "Não foi possível substituir Cartão: " + resultado.response.data.mensagens.map(mensagem => mensagem).join(" ,"));
    });
  }

  const handleMarcarCartoes = (ids, obj) => {
    if (obj && obj.length > 0) {
      setListaDeCartoesMarcados({
        codigoInep: obj[0].original.codigoInep,
        escolaNome: obj[0].original.escola,
        cartoes: obj.map(cartao => {
          return { id: cartao.id, nivel: cartao.nivel, codigo: cartao.codigo };
        }
        )
      });
    } else {
      setListaDeCartoesMarcados({});
    }
  }

  const handleModalMoverCartaoParaCaixaDaEscola = (id) => {
    setCartaoSelecionado(cartoes.find(c => c.id === id));
    setPosicaoCartaoSelecionado(cartoes.findIndex(c => c.id === id));
    setOpenDialogMoverCartaoParaCaixaDaEscola(true);
  }

  const handleMoverCartaoParaCaixaDaEscola = (id) => {
    EscolaService.colocarCartaoNaMesmaCaixaDaEscola(processo, cartaoSelecionado.id)
      .then(res => {
        toastRef.current.show("success", "Cartão Adicionado na mesma Caixa da Escola.");
        setOpenDialogMoverCartaoParaCaixaDaEscola(false);
        buscarCartoes();
      })
      .catch(err => toastRef.current.show("error", "Não foi possível Trocar a Caixa do Cartão para a Mesma Caixa da Escola."))
  }

  const handleMarcarCartaoLegivel = (id, codigo, codigoInformadoManualmente, setLoading, onErro) => {

    const formData = new FormData();
    formData.append('codigo', codigo);
    formData.append('codigoInformadoManualmente', codigoInformadoManualmente);    

    EscolaService.cartaoLegivel(processo, cartaoSelecionado.id, formData)
      .then(res => {
        toastRef.current.show("success", "Cartão marcardo com legível com sucesso!");
        setOpenDialogCartaoArquivoLegivel(false);
        setOpenModalVisualizarArquivo(false);

        if (props.aoMarcarCartaoComoLegivel) {
          props.aoMarcarCartaoComoLegivel(cartaoSelecionado.id, cartoes, setCartoes);
        } else
          buscarCartoes();
      }).catch(err => {

        const mensagens = err?.response?.data?.mensagens;

        const mensagem = (Array.isArray(mensagens) && mensagens.length > 0)
            ? mensagens[0]
            : "Não foi possível marcar o cartão como legível.";

        toastRef.current.show("error", mensagem);
        onErro(mensagem);

      }).finally(() => {
        setLoading(false);
      });
  }


  const visualizarArquivo = useCallback((id, openModalVisualizarArquivo = true) => {
    const cartao = cartoes.find(c => c.id === id);
    const posicaoCartao = cartoes.findIndex(c => c.id === id);

    if (cartao.nomeArquivo) {
      setOpenModalVisualizarArquivo(openModalVisualizarArquivo);
      setCartaoSelecionado(cartao);
      setPosicaoCartaoSelecionado(posicaoCartao);
      setLoadingDialog(true);

      EscolaService.downloadArquivoCartao(processo, undefined, cartao.id).then(resultado => {
        setBlob(resultado.data);
        setLoadingDialog(false);

      }).catch(erro => {
        toastRef.current.show("error", "Não foi posível fazer download do arquivo.");
      });
    } else {
      alert("Arquivo inexistente");
    }
  }, [cartoes, processo]);

  const actions = []

  if (props.exibeActions === undefined || props.exibeActions === true) {
    if (props.permiteEditarCartao === undefined || props.permiteEditarCartao === true)
      actions.push({
        name: () => "Editar",
        func: abrirModalEdicao,
        icon: <ModeEditIcon />,
        disabled: (id, cartao) => cartao.status === "DESCARTADO",
        collapse: true
      });

    actions.push({
      func: (id) => visualizarArquivo(id),
      icon: <CardIcon />,
      disabled: (id) => {
        const cartao = cartoes.find(c => c.id === id);
        return (cartao.nomeArquivo === "") || (cartao.nomeArquivo === null) || (cartao.nomeArquivo === undefined);
      },
      name: (id) => {
        const cartao = cartoes.find(c => c.id === id);
        return (cartao.nomeArquivo === "") || (cartao.nomeArquivo === null) || (cartao.nomeArquivo === undefined) ? "Não existe arquivo digitalizado." : "Visualizar Digitalização";
      },
      collapse: true
    });

    if ((AuthorizedFunction(["__processo.usuario.central"]) || AuthorizedFunction(["__processo.usuario.operador"]))) {
      if (props.permiteReetiquetar === undefined || props.permiteReetiquetar === true)
        actions.push({
          name: (c, l) => "Transferir (Reetiquetar)",
          func: (id, obj) => handleTransferirCartao(obj),
          icon: <SwapHorizIcon />,
          disabled: () => false,
          collapse: true
        });
    }

    if (props.permiteAnexarDigitalizacao === undefined || props.permiteAnexarDigitalizacao === true)
      actions.push({
        name: () => "Anexar Digitalização",
        func: abrirModalUploadArquivo,
        icon: <AttachIcon />,
        disabled: (id, cartao) => cartao.status === "DESCARTADO",
        collapse: true
      });

    if ((AuthorizedFunction(["__processo.usuario.central"]) || AuthorizedFunction(["__processo.usuario.operador"]))) {
      if (props.permiteSubstituirCartao === undefined || props.permiteSubstituirCartao === true)
        actions.push({
          name: () => "Substituir Cartão",
          func: abrirModalSubstituicao,
          icon: <RefreshIcon />,
          disabled: (id, cartao) => cartao.substituido || cartao.status === "DESCARTADO",
          collapse: true
        });
    }

    if (props.permiteTratarPendenciaNome !== undefined && props.permiteTratarPendenciaNome === true)
      actions.push({
        name: () => "Tratar Nome",
        func: (id) => {
          setCartaoSelecionado(cartoes.find(c => c.id === id));
          setPosicaoCartaoSelecionado(cartoes.findIndex(c => c.id === id));
          setOpenDialogTratamentoNome(true);
        },
        icon: <AssignmentTurnedInIcon />,
        disabled: () => false,
        collapse: true
      });

    if (props.permiteTratarPendenciaNota !== undefined && props.permiteTratarPendenciaNota === true)
      actions.push({
        name: () => "Tratar Nota",
        func: abrirModalTratamentoNota,
        icon: <AssignmentTurnedInIcon />,
        disabled: () => false,
        collapse: true
      });

    if (props.permiteTratarPendenciaDataNascimento !== undefined && props.permiteTratarPendenciaDataNascimento === true)
      actions.push({
        name: () => "Tratar Data de Nascimento",
        func: (id) => {
          setCartaoSelecionado(cartoes.find(c => c.id === id));
          setPosicaoCartaoSelecionado(cartoes.findIndex(c => c.id === id));
          setOpenDialogTratamentoDataNascimento(true);
        },
        icon: <AssignmentTurnedInIcon />,
        disabled: () => false,
        collapse: true
      });

      if (props.permiteTratarPendenciaCPF !== undefined && props.permiteTratarPendenciaCPF === true)
        actions.push({
          name: () => "Tratar CPF",
          func: (id) => {
            setCartaoSelecionado(cartoes.find(c => c.id === id));
            setPosicaoCartaoSelecionado(cartoes.findIndex(c => c.id === id));
            setOpenDialogTratamentoCPF(true);
          },
          icon: <AssignmentTurnedInIcon />,
          disabled: () => false,
          collapse: true
        });

    if ((AuthorizedFunction(["__processo.usuario.central"]) || AuthorizedFunction(["__processo.usuario.operador"]))) {
      if (props.permiteMoverCartaoParaCaixaDaEscola)
        actions.push({
          name: () => "Mover Cartão para Caixa da Escola",
          func: (id) => handleModalMoverCartaoParaCaixaDaEscola(id),
          icon: <ImportExportOutlinedIcon />,
          disabled: () => false,
          collapse: true
        });
    }

    actions.push({
      name: (c, l) => "Arquivo Legível",
      func: (id, teste) => {
        setCartaoSelecionado(cartoes.find(c => c.id === id));
        setPosicaoCartaoSelecionado(cartoes.findIndex(c => c.id === id));
        setOpenDialogCartaoArquivoLegivel(true);
      },
      icon: (col, l) => <RestoreFromTrashIcon />,
      disabled: (id, cartao) => cartao.arquivoLegivel === undefined || cartao.arquivoLegivel === true || cartao.ilegibilidade === 'CODIGO',
      collapse: true
    });

    if ((AuthorizedFunction(["__processo.usuario.central"]) || AuthorizedFunction(["__processo.usuario.operador"]))) {
      if (props.permiteDescartarCartao !== undefined && props.permiteDescartarCartao === true)
        actions.push({
          name: (c, l) => l.status && l.status === "DESCARTADO" && !l.substituido ? "Restaurar Cartão" : "Descartar Cartão",
          func: (id, teste) => {
            let c = cartoes.find(c => c.id === id);
            if (c.status && c.status === "DESCARTADO") {
              setCartaoSelecionado(cartoes.find(c => c.id === id));
              setPosicaoCartaoSelecionado(cartoes.findIndex(c => c.id === id));
              setOpenDialogRestaurarCartao(true);
            } else {
              setCartaoSelecionado(cartoes.find(c => c.id === id));
              setPosicaoCartaoSelecionado(cartoes.findIndex(c => c.id === id));
              setOpenDialogDescartarCartao(true);
            }
          },
          icon: (col, l) => l.status && l.status === "DESCARTADO" && !l.substituido ? <RestoreFromTrashIcon /> : <DeleteOutlinedIcon />,
          color: (c, l) => l.status && l.status === "DESCARTADO" ? "primary" : "secondary",
          disabled: (id, cartao) => cartao.substituido,
          collapse: true
        });
    }
  }

  const restaurarCartao = (cartao, setLoading) => {
    EscolaService.restaurarCartao(processo, cartao.id).then(() => {
      setOpenDialogRestaurarCartao(false);
      setLoading(false);

      if (props.aoRestaurarCartao)
        props.aoRestaurarCartao();
    });
  }

  const contarFiltrosAplicados = () => quantidadeFiltrosAplicados;

  const limparCampos = () => {
    setFiltroOrigem('');
    setFiltroNome('');
    setFiltroCodigo('');
    setFiltroNivel('');
    setFiltroCaixa('');
    setFiltroCodigoInep('');
    setFiltroStatusTratamentoNome("");
    setFiltroTipoTratamentoNome("");
    setFiltroTipoIlegibilidade("");
    setFiltroStatusTratamentoNomeDuplicado("");
    setFiltroStatusTratamentoNota("");
    setFiltroTipoTratamentoNota("");
    setFiltroStatusTratamentoDataNascimento("");
    setFiltroTipoTratamentoDataNascimento("");
    setFiltroStatusTratamentoCPF("");
    setFiltroTipoTratamentoCPF("");
    setFiltroAtivo(false);
    setFiltroStatus('');
    setFiltroDiscrepancia('');
    setFiltroNota('');
    setFiltroNotaCalculada('');
    setFiltroDuplicidade('');
    setFiltroDtNasc(null);
    setFiltroObjetoPostal('');
    setFiltroComEscolaAssociada('');
    setFiltroUF('');
    setFiltroMarcadoComoIlegivel('');
    setFiltroMarcadoComoLegivel('');
    setFiltroDigitado('');
    setFiltroEmailDigitado('');
    setFiltroEtiquetado('');
    setFiltroDigitadoMarcacoes('');
    setFiltroLidoPeloOCRTexto('');
    setFiltroLidoPeloOCR('');
    setFiltroCortado('');
    setFiltroSomenteValidos('');
    setFiltroSomenteCartoesEmProcessamento('');
    setFiltroSomenteComDivergenciaNotaSemDigitador('');
    setFiltroParticipaSegundaFase('');
  }

  const limparFiltros = () => {
    setSort([{ orderBy: defaultOrderBy, order: ASC }]);
    setPage(PAGE);
    setSize(SIZE);

    setFiltros([]);
    limparCampos();

    if (props.sessionStorage)
      sessionStorage.removeItem(props.sessionStorage);

    if (props.aoLimparFiltro)
      props.aoLimparFiltro();

    setQuantidadeFiltrosAplicados(0);
  }

  const verificarFiltrosQueryString = useCallback((filtros) => {
    let f = [...filtros];

    if (props.sessionStorage) {
      const sessionFilters = JSON.parse(sessionStorage.getItem(props.sessionStorage) || '[]');

      sessionFilters.forEach(filtro => {
        if (setters[filtro.field])
          setters[filtro.field](filtro.value);
      });

      f = f.concat(sessionFilters);
    }

    f = removeDuplicatas(f);

    if (new URLSearchParams(search).get("codigoInep")) {
      f.push({ field: 'inep', value: new URLSearchParams(search).get("codigoInep") });
      setFiltroCodigoInep(new URLSearchParams(search).get("codigoInep"))
    }

    if (new URLSearchParams(search).get("nomeAluno")) {
      f.push({ field: 'nome', value: new URLSearchParams(search).get("nomeAluno") });
      setFiltroNome(new URLSearchParams(search).get("nomeAluno"))
    }
    if (new URLSearchParams(search).get("status")) {
      f.push({ field: 'status', value: new URLSearchParams(search).get("status") });
      setFiltroStatus(new URLSearchParams(search).get("status"))
    }

    if (new URLSearchParams(search).get("emprocessamento")) {
      f.push({ field: 'emprocessamento', value: new URLSearchParams(search).get("emprocessamento") });
      setFiltroSomenteCartoesEmProcessamento(new URLSearchParams(search).get("emprocessamento"))
    }

    if (new URLSearchParams(search).get("emailDigitado")) {
      f.push({ field: 'emailDigitado', value: new URLSearchParams(search).get("emailDigitado") });
      setFiltroEmailDigitado(new URLSearchParams(search).get("emailDigitado"))
    }

    if (new URLSearchParams(search).get("somenteComDivergenciaNotaSemDigitador")) {
      f.push({ field: 'somenteComDivergenciaNotaSemDigitador', value: new URLSearchParams(search).get("somenteComDivergenciaNotaSemDigitador") });
      setFiltroSomenteComDivergenciaNotaSemDigitador(new URLSearchParams(search).get("somenteComDivergenciaNotaSemDigitador"))
    }

    if (f.length > 0) {
      setFiltroAtivo(true);
    } else {
      setFiltroAtivo(filtroAtivo);
    }

    setQuantidadeFiltrosAplicados(f.filter(f =>
      f.field !== "somenteComTratamentoNome" ||
      f.field !== "somenteComTratamentoNomeDuplicado" ||
      f.field !== "somenteComTratamentoNota" ||
      f.field !== "somenteComTratamentoDataNascimento" ||
      f.field !== "somenteComTratamentoCPF"
    ).length);

    return f;
  }, [filtroAtivo, props.sessionStorage, search, setters]);

  const verificarFiltrosProps = useCallback((filtros) => {
    let f = [...filtros];

    if (props.escola) {
      f.push({ field: 'inep', value: props.escola });
      setFiltroCodigoInep(props.escola)
    }

    if (props.nivel) {
      f.push({ field: 'nivel', value: props.nivel });
      setFiltroNivel(props.nivel)
    }

    if (props.caixa) {
      f.push({ field: 'caixa', value: props.caixa });
      setFiltroCaixa(props.caixa)
    }

    if (props.somenteComDuplicidadeNaoTratada) {
      f = f.filter(f => f.field !== "comDuplicidade")
      f.push({ field: 'comDuplicidade', value: "DUPLICIDADE_NAO_TRATADA" });
      setFiltroDuplicidade("DUPLICIDADE_NAO_TRATADA");
    }

    if (props.somenteComTratamentoNome) {
      f = f.filter(f => f.field !== "somenteComTratamentoNome")
      f.push({ field: 'somenteComTratamentoNome', value: props.somenteComTratamentoNome });
      setFiltroSomenteComTratamentoNome(props.somenteComTratamentoNome);
    }

    if (props.filtroStatusTratamentoNome) {
      f = f.filter(f => f.field !== "statusTratamentoNome")
      f.push({ field: 'statusTratamentoNome', value: props.filtroStatusTratamentoNome });
      setFiltroStatusTratamentoNome(props.filtroStatusTratamentoNome);
    }

    if (props.filtroTipoTratamentoNome) {
      f = f.filter(f => f.field !== "tipoPendenciaTratamentoNome")
      f.push({ field: 'tipoPendenciaTratamentoNome', value: props.filtroTipoTratamentoNome });
      setFiltroTipoTratamentoNome(props.filtroTipoTratamentoNome);
    }

    if (props.filtroTipoIlegibilidade) {
      f = f.filter(f => f.field !== "tipoIlegibilidade")
      f.push({ field: 'tipoIlegibilidade', value: props.filtroTipoIlegibilidade });
      setFiltroTipoIlegibilidade(props.filtroTipoIlegibilidade);
    }

    if (props.somenteComTratamentoNomeDuplicado) {
      f = f.filter(f => f.field !== "somenteComTratamentoNomeDuplicado")
      f.push({ field: 'somenteComTratamentoNomeDuplicado', value: props.somenteComTratamentoNomeDuplicado });
      setFiltroSomenteComTratamentoNomeDuplicado(props.somenteComTratamentoNomeDuplicado);
    }

    if (props.filtroStatusTratamentoNomeDuplicado && filtroStatusTratamentoNomeDuplicado === "") {
      f = f.filter(f => f.field !== "statusTratamentoNomeDuplicado")
      f.push({ field: 'statusTratamentoNomeDuplicado', value: props.filtroStatusTratamentoNomeDuplicado });
      setFiltroStatusTratamentoNomeDuplicado(props.filtroStatusTratamentoNomeDuplicado);
    }

    if (props.filtroTipoTratamentoNota) {
      f = f.filter(f => f.field !== "tipoPendenciaTratamentoNota")
      f.push({ field: 'tipoPendenciaTratamentoNota', value: props.filtroTipoTratamentoNota });
      setFiltroTipoTratamentoNota(props.filtroTipoTratamentoNota);
    }

    if (props.somenteComTratamentoNota) {
      f = f.filter(f => f.field !== "somenteComTratamentoNota")
      f.push({ field: 'somenteComTratamentoNota', value: props.somenteComTratamentoNota });
      setFiltroSomenteComTratamentoNota(props.somenteComTratamentoNota);
    }

    if (!filtroStatusTratamentoNota && props.somenteComTratamentoNotaPendente) {
      f = f.filter(f => f.field !== "somenteComTratamentoNotaPendente")
      f.push({ field: 'somenteComTratamentoNotaPendente', value: props.somenteComTratamentoNotaPendente });
      setFiltroSomenteComTratamentoNotaPendente(props.somenteComTratamentoNotaPendente);
    }

    if (props.somenteComTratamentoDataNascimento) {
      f = f.filter(f => f.field !== "somenteComTratamentoDataNascimento")
      f.push({ field: 'somenteComTratamentoDataNascimento', value: props.somenteComTratamentoDataNascimento });
      setFiltroSomenteComTratamentoDataNascimento(props.somenteComTratamentoDataNascimento);
    }

    if (props.filtroStatusTratamentoDataNascimento) {
      f = f.filter(f => f.field !== "statusTratamentoDataNascimento")
      f.push({ field: 'statusTratamentoDataNascimento', value: props.filtroStatusTratamentoDataNascimento });
      setFiltroStatusTratamentoDataNascimento(props.filtroStatusTratamentoDataNascimento);
    }

    if (props.somenteComTratamentoCPF) {
      f = f.filter(f => f.field !== "somenteComTratamentoCpf")
      f.push({ field: 'somenteComTratamentoCpf', value: props.somenteComTratamentoCPF });
      setFiltroSomenteComTratamentoCPF(props.somenteComTratamentoCPF);
    }

    if (props.filtroStatusTratamentoCPF) {
      f = f.filter(f => f.field !== "statusTratamentoCpf")
      f.push({ field: 'statusTratamentoCpf', value: props.filtroStatusTratamentoCPF });
      setFiltroStatusTratamentoCPF(props.filtroStatusTratamentoCPF);
    }

    if (props.filtroCartaoEmCaixaDiferenteDaEscola) {
      f = f.filter(f => f.field !== "cartaoEmCaixaDiferenteDaEscola")
      f.push({ field: 'cartaoEmCaixaDiferenteDaEscola', value: true });
      setFiltroCartaoEmCaixaDiferenteDaEscola(true);
    }

    if (props.filtroObjetoPostal) {
      f = f.filter(f => f.field !== "objetoPostal")
      f.push({ field: 'objetoPostal', value: props.filtroObjetoPostal });
      setFiltroObjetoPostal(props.filtroObjetoPostal);
    }

    if (props.filtroComEscolaAssociada !== undefined && (props.filtroComEscolaAssociada + "") !== "") {
      f = f.filter(f => f.field !== "comEscolaAssociada")
      f.push({ field: 'comEscolaAssociada', value: props.filtroComEscolaAssociada });
      setFiltroComEscolaAssociada(props.filtroComEscolaAssociada);
    }

    if (props.filtroMarcadoComoIlegivel) {
      f = f.filter(f => f.field !== "ilegivel")
      f.push({ field: 'ilegivel', value: true });
      setFiltroMarcadoComoIlegivel(true);
    }

    if (props.filtroMarcadoComoLegivel) {
      f = f.filter(f => f.field !== "legivel")
      f.push({ field: 'legivel', value: true });
      setFiltroMarcadoComoLegivel(true);
    }

    if (f.length > 0) {
      setFiltroAtivo(true);
    } else {
      setFiltroAtivo(filtroAtivo);
    }

    setQuantidadeFiltrosAplicados(f.filter(f =>
      f.field !== "somenteComTratamentoNome" ||
      f.field !== "somenteComTratamentoNomeDuplicado" ||
      f.field !== "somenteComTratamentoNota" ||
      f.field !== "somenteComTratamentoDataNascimento" ||
      f.field !== "somenteComTratamentoCpf"
    ).length);

    return f;
  }, [filtroAtivo, filtroStatusTratamentoNomeDuplicado, filtroStatusTratamentoNota, 
    props.caixa, props.escola, props.filtroCartaoEmCaixaDiferenteDaEscola, props.filtroComEscolaAssociada, props.filtroMarcadoComoIlegivel, 
    props.filtroMarcadoComoLegivel, props.filtroObjetoPostal, props.filtroStatusTratamentoDataNascimento, props.filtroStatusTratamentoNome, props.filtroStatusTratamentoCPF, 
    props.filtroStatusTratamentoNomeDuplicado, props.filtroTipoIlegibilidade, props.filtroTipoTratamentoNome, props.filtroTipoTratamentoNota,
    props.nivel, props.somenteComDuplicidadeNaoTratada, props.somenteComTratamentoDataNascimento, props.somenteComTratamentoNome, props.somenteComTratamentoCPF,
    props.somenteComTratamentoNomeDuplicado, props.somenteComTratamentoNota, props.somenteComTratamentoNotaPendente]);

  const buscarCartoes = useCallback(() => {
    if (processo !== undefined) {
      setLoading(true);

      const f = verifyPagingAndSorting(removePagingAndSorting(verificarFiltrosProps(verificarFiltrosQueryString(filtros))), page, size, sort, filtroAtivo);

      EscolaService.buscarCartoes(processo, f).then(resultado => {
        const { content, number, size, totalElements, totalPages } = resultado.data;
        setCartoes(content);
        setPage(number);
        setSize(size);
        setTotalElements(totalElements);
        setTotalPages(totalPages);
        setTotalPages(totalPages);
        setLoading(false);
      });
    }
  }, [processo, filtros, filtroAtivo, verificarFiltrosProps, verificarFiltrosQueryString, page, size, sort]);

  useEffect(() => buscarCartoes(), [buscarCartoes, props.refresh]);

  useEffect(() => {
    if (callback) {
      aplicarFiltros();
      setCallback(null);
    }
  }, [callback, aplicarFiltros]);

  const handlePage = page => {
    setPage(page);
    setFiltroAtivo(true)
  };

  const handleRowsPerPage = (size, page) => {
    setPage(page);
    setSize(size);
    setFiltroAtivo(true)
  };

  const handleSort = (orderBy, order) => {
    if (sort.find(s => s.orderBy === verifyOrderBy(orderBy))) {
      let newSort = sort.filter(s => s.orderBy !== verifyOrderBy(orderBy));
      newSort.splice(sort.indexOf(sort.find(s => s.orderBy === verifyOrderBy(orderBy))), 0, {
        orderBy: verifyOrderBy(orderBy),
        order: order
      })
      setSort([...newSort]);
    } else {
      setSort([...sort.filter(s => s.orderBy !== verifyOrderBy(orderBy)), {
        orderBy: verifyOrderBy(orderBy),
        order: order
      }]);
    }
    setFiltroAtivo(true)
  }

  const handleClearSort = (orderBy) => {
    setFiltroAtivo(true);
    orderBy ? setSort([...sort.filter(s => s.orderBy !== verifyOrderBy(orderBy))]) : setSort([{
      orderBy: defaultOrderBy,
      order: ASC
    }])
  };

  const handleTotalPages = () => totalPages;
  const handleTotalElements = () => totalElements;

  const closeModalEdicao = (event, reason) => {
    if (reason === "backdropClick")
      return false;

    setOpenDialogEdicao(false);
  }

  // LOGICA DAS SETAS NO MODAL DE VISUALIZAR E EDITAR CARTOES ---
  useEffect(() => {
    if (!openModalVisualizarArquivo && !openDialogEdicao)
      return;

    const handleKeyDown = (event) => {
      const elementoAtivo = document.activeElement;
      const isCampoFormulario = ['INPUT', 'TEXTAREA', 'SELECT', 'BUTTON'].includes(elementoAtivo.tagName) || elementoAtivo.getAttribute('contenteditable') === 'true';

      if (isCampoFormulario)
        return;

      let posicao = posicaoCartaoSelecionado;
      let pagina = page;

      const isPrimeiraPagina = pagina === 0;
      const isPrimeiroRegistroPagina = posicao === 0;
      const isPrimeiroRegistro = isPrimeiroRegistroPagina && isPrimeiraPagina;

      const isUltimaPagina = pagina + 1 === totalPages;
      const posicaoMaximaPagina = isUltimaPagina && totalElements % size !== 0 ? totalElements % size : size;
      const isUltimoRegistroPagina = posicao + 1 === posicaoMaximaPagina;
      const isUltimoRegistro = isUltimoRegistroPagina && isUltimaPagina;

      switch (event.key) {
        case 'ArrowLeft': {
          if (isPrimeiroRegistro)
            break;

          if (isPrimeiroRegistroPagina) {
            pagina--;
            handlePage(pagina);
            setPosicaoCartaoSelecionado(9);
          } else {
            posicao--;
            setPosicaoCartaoSelecionado(posicao);
          }

          break;
        }
        case 'ArrowRight': {
          if (isUltimoRegistro)
            break;

          if (isUltimoRegistroPagina) {
            pagina++;
            handlePage(pagina);
            setPosicaoCartaoSelecionado(0);
          } else {
            posicao++;
            setPosicaoCartaoSelecionado(posicao);
          }

          break;
        }
        default:
          break;
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [openModalVisualizarArquivo, openDialogEdicao, posicaoCartaoSelecionado, page, size, totalElements, totalPages]);

  useEffect(() => {
    if ((openModalVisualizarArquivo || openDialogEdicao) && cartoes.length > 0 && posicaoCartaoSelecionado !== null) {
      const cartao = cartoes[posicaoCartaoSelecionado];
      if (cartao) {
        visualizarArquivo(cartao.id, openModalVisualizarArquivo);
      }
    }
  }, [openModalVisualizarArquivo, openDialogEdicao, cartoes, posicaoCartaoSelecionado, visualizarArquivo]);
  // --- LOGICA DAS SETAS NO MODAL DE VISUALIZAR E EDITAR CARTOES

  return (
    <>
      <Toast ref={toastRef} />
      <br />
      {(props.exibeFiltro === undefined || props.exibeFiltro === true) &&
        <Filters
          handleFilter={aplicarFiltros}
          handleFilterClear={limparFiltros}
          countFilters={contarFiltrosAplicados}
        >
          <Grid item container spacing={3}>
            <Grid item sm={12} lg={4}>
              <TextField
                label='Nome Aluno'
                value={filtroNome}
                name='filtroNome'
                onChange={(e) => setFiltroNome(e.target.value)}
              />
            </Grid>

            <Grid item sm={1} lg={1}>
              <SelectOption
                label='UF'
                value={filtroUF}
                name='filtroUF'
                onChange={(e) => setFiltroUF(e.target.value)}
                options={listagemUF.data} />
            </Grid>

            <Grid item sm={12} lg={2}>
              <TextField
                label='Escola'
                value={filtroCodigoInep}
                name='filtroCodigoInep'
                inputProps={{ maxLength: 8 }}
                onChange={(e) => props.escola !== undefined ? "" : setFiltroCodigoInep(e.target.value.trim())}
              />
            </Grid>

            <Grid item sm={12} lg={3}>
              <TextField
                label='Objeto Postal'
                value={filtroObjetoPostal}
                name='filtroObjetoPostal'
                onChange={(e) => setFiltroObjetoPostal(e.target.value)}
              />
            </Grid>

            <Grid item sm={6} lg={1}>
              <SelectOption
                label='Caixa'
                value={filtroCaixa}
                name='filtroCaixa'
                onChange={(e) => props.caixa !== undefined ? "" : setFiltroCaixa(e.target.value)}
                options={listagemCaixas.data}
                disabled={listagemCaixas.data.length === 0}
              />
            </Grid>
          </Grid>

          {(AuthorizedFunction(["__processo.usuario.central"]) || AuthorizedFunction(["__processo.usuario.operador"])) &&
            <Grid item container spacing={3}>
              <Grid item sm={12} lg={4}>
                <TextField
                  label='Código do Cartão'
                  value={filtroCodigo}
                  name='filtroCodigo'
                  inputProps={{ maxLength: 16 }}
                  onChange={(e) => setFiltroCodigo(e.target.value.trim())}
                />
              </Grid>

              <Grid item sm={12} lg={3}>
                <SelectOption
                  label='Origem do Cartão'
                  value={filtroOrigem}
                  name='filtroOrigem'
                  onChange={(e) => setFiltroOrigem(e.target.value)}
                  options={listagemOrigem.data}
                />
              </Grid>

              <Grid item sm={12} lg={2}>
                <SelectOption
                  label='Nível'
                  value={filtroNivel}
                  name='filtroNivel'
                  onChange={(e) => setFiltroNivel(e.target.value)}
                  options={[
                    { "label": "1", "value": "1" },
                    { "label": "2", "value": "2" },
                    { "label": "3", "value": "3" },
                  ]}
                />
              </Grid>

              <Grid item sm={12} lg={3}>
                <SelectOption
                  label='Status'
                  value={filtroStatus}
                  name='filtroStatus'
                  onChange={(e) => setFiltroStatus(e.target.value)}
                  options={listagemStatus.data}
                />
              </Grid>

              <Grid item sm={12} lg={2}>
                <SelectOption
                  label='Nota Digitada'
                  value={filtroNota}
                  name='filtroNota'
                  onChange={(e) => setFiltroNota(e.target.value)}
                  options={optionsNotasEnum}
                />
              </Grid>

              <Grid item sm={12} lg={2}>
                <SelectOption
                  label='Nota Calculada'
                  value={filtroNotaCalculada}
                  name='filtroNotaCalculada'
                  onChange={(e) => setFiltroNotaCalculada(e.target.value)}
                  options={optionsNotasEnum}
                />
              </Grid>

              <Grid item sm={12} lg={3}>
                <SelectOption
                  label='Discrepância de nota > que'
                  value={filtroDiscrepancia}
                  name='filtroDiscrepancia'
                  onChange={(e) => setFiltroDiscrepancia(e.target.value)}
                  options={optionsDiscrepanciaEnum}
                />
              </Grid>

              <Grid item sm={12} lg={3}>
                <SelectOption
                  label='Participa Segunda Fase'
                  value={filtroParticipaSegundaFase}
                  name='filtroParticipaSegundaFase'
                  onChange={(e) => setFiltroParticipaSegundaFase(e.target.value)}
                  options={[
                    { "value": "NAO_INFORMADO", "label": "Não Informado" },
                    { "value": "SIM", "label": "Sim" },
                    { "value": "NAO", "label": "Não" },
                    { "value": "SIM_NAO", "label": "Sim e Não" },
                  ]}
                />
              </Grid>
            </Grid>
          }

          {props.exibeFiltroTratamentoNome &&
            <Grid item container spacing={3}>
              <Grid item sm={12} lg={3}>
                <SelectOption
                  label='Tipo Tratamento Nome'
                  value={filtroTipoTratamentoNome ?? ""}
                  name='filtroTipoTratamentoNome'
                  onChange={(e) => setFiltroTipoTratamentoNome(e.target.value)}
                  options={listagemTiposNome.data}
                />
              </Grid>

              <Grid item sm={12} lg={3}>
                <SelectOption
                  label='Status Tratamento Nome'
                  value={filtroStatusTratamentoNome ?? ""}
                  name='filtroStatusTratamentoNome'
                  onChange={(e) => setFiltroStatusTratamentoNome(e.target.value)}
                  options={listagemStatusTratamentoNome.data}
                />
              </Grid>
            </Grid>
          }

          {props.exibeFiltroTratamentoNomeDuplicado &&
            <Grid item container spacing={3}>
              <Grid item sm={12} lg={3}>
                <SelectOption
                  label='Status Tratamento Nome Duplicado'
                  value={filtroStatusTratamentoNomeDuplicado ?? ""}
                  name='filtroStatusTratamentoNomeDuplicado'
                  onChange={(e) => setFiltroStatusTratamentoNomeDuplicado(e.target.value)}
                  options={listagemStatusTratamentoNomeDuplicado.data}
                />
              </Grid>
            </Grid>
          }

          {props.exibeFiltroTratamentoDataNascimeto &&
            <Grid item container spacing={3}>
              <Grid item sm={12} lg={3}>
                <SelectOption
                  label='Tipo Tratamento Data de Nascimento'
                  value={filtroTipoTratamentoDataNascimento ?? ""}
                  name='filtroTipoTratamentoDataNascimento'
                  onChange={(e) => setFiltroTipoTratamentoDataNascimento(e.target.value)}
                  options={listagemTiposDataNascimento.data}
                />
              </Grid>

              <Grid item sm={12} lg={3}>
                <SelectOption
                  label='Status Tratamento Data de Nascimento'
                  value={filtroStatusTratamentoDataNascimento ?? ""}
                  name='filtroStatusTratamentoDataNascimento'
                  onChange={(e) => setFiltroStatusTratamentoDataNascimento(e.target.value)}
                  options={listagemStatusTratamentoDataNascimento.data}
                />
              </Grid>
            </Grid>
          }

          {props.exibeFiltroTratamentoCpf &&
            <Grid item container spacing={3}>
              <Grid item sm={12} lg={3}>
                <SelectOption
                  label='Tipo Tratamento CPF'
                  value={filtroTipoTratamentoCPF ?? ""}
                  name='filtroTipoTratamentoCPF'
                  onChange={(e) => setFiltroTipoTratamentoCPF(e.target.value)}
                  options={listagemTiposCPF.data}
                />
              </Grid>

              <Grid item sm={12} lg={3}>
                <SelectOption
                  label='Status Tratamento CPF'
                  value={filtroStatusTratamentoCPF ?? ""}
                  name='filtroStatusTratamentoCPF'
                  onChange={(e) => setFiltroStatusTratamentoCPF(e.target.value)}
                  options={listagemStatusTratamentoCPF.data}
                />
              </Grid>
            </Grid>
          }

          <Grid item container spacing={3}>
            {(AuthorizedFunction(["__processo.usuario.central"]) || AuthorizedFunction(["__processo.usuario.operador"])) &&
              <Grid item sm={12} lg={2}>
                <SelectOption
                  label='Duplicado'
                  value={filtroDuplicidade}
                  name='filtroDuplicidade'
                  onChange={(e) => setFiltroDuplicidade(e.target.value)}
                  disabled={props.somenteComDuplicidadeNaoTratada}
                  options={[
                    { "value": "DUPLICIDADE_TODOS", "label": "Sim (Todas)" },
                    { "value": "DUPLICIDADE_TRATADA", "label": "Sim (Tratada)" },
                    { "value": "DUPLICIDADE_NAO_TRATADA", "label": "Sim (Não Tratada)" },
                    { "value": "DUPLICIDADE_NAO", "label": "Não" },
                  ]}
                />
              </Grid>
            }

            <Grid item sm={12} lg={2}>
              <Boolean
                label='Reetiquetado'
                value={filtroEtiquetado}
                name='filtroEtiquetado'
                onChange={(e) => setFiltroEtiquetado(e.target.value)}
              />
            </Grid>

            <Grid item sm={12} lg={2}>
              <Boolean
                label='Cortado'
                value={filtroCortado}
                name='filtroCortado'
                onChange={(e) => setFiltroCortado(e.target.value)}
              />
            </Grid>

            <Grid item sm={12} lg={2}>
              <Boolean
                label='OCR (Texto)'
                value={filtroLidoPeloOCRTexto}
                name='filtroLidoPeloOCRTexto'
                onChange={(e) => setFiltroLidoPeloOCRTexto(e.target.value)}
              />
            </Grid>

            <Grid item sm={12} lg={2}>
              <Boolean
                label='Digitado (Texto)'
                value={filtroDigitado}
                name='filtroDigitado'
                onChange={(e) => setFiltroDigitado(e.target.value)}
              />
            </Grid>

            <Grid item sm={12} lg={2}>
              <Boolean
                label='Email Digitado'
                value={filtroEmailDigitado}
                name='filtroEmailDigitado'
                onChange={(e) => setFiltroEmailDigitado(e.target.value)}
              />
            </Grid>

            <Grid item sm={12} lg={2}>
              <Boolean
                label='OCR (Marcações)'
                value={filtroLidoPeloOCR}
                name='filtroLidoPeloOCR'
                onChange={(e) => setFiltroLidoPeloOCR(e.target.value)}
              />
            </Grid>

            <Grid item sm={12} lg={2}>
              <Boolean
                label='Digitado (Marcações)'
                value={filtroDigitadoMarcacoes}
                name='filtroDigitadoMarcacoes'
                onChange={(e) => setFiltroDigitadoMarcacoes(e.target.value)}
              />
            </Grid>

            <Grid item sm={12} lg={2} style={{ display: 'flex', alignSelf: "center" }}>
              <CheckBox
                label='Somente Legiveis'
                checked={filtroMarcadoComoLegivel}
                name='filtroMarcadoComoLegivel'
                onChange={(e) => setFiltroMarcadoComoLegivel(e.target.checked)}
                disabled={props.filtroMarcadoComoLegivel}
              />
            </Grid>

            <Grid item sm={12} lg={2} style={{ display: 'flex', alignSelf: "center" }}>
              <CheckBox
                label='Somente Ilegiveis'
                checked={filtroMarcadoComoIlegivel}
                name='filtroMarcadoComoIlegivel'
                onChange={(e) => setFiltroMarcadoComoIlegivel(e.target.checked)}
                disabled={props.filtroMarcadoComoIlegivel}
              />
            </Grid>

            <Grid item sm={12} lg={3} style={{ display: 'flex', alignSelf: "center" }}>
              <Select
                label='Tipo Ilegibilidade'
                value={filtroTipoIlegibilidade}
                options={[
                  { label: 'Código', value: 'CODIGO' },
                  { label: 'Arquivo não encontrado', value: 'NAO_ENCONTRADO' },
                  { label: 'Corrompido', value: 'CORROMPIDO' },
                  { label: 'Texto', value: 'TEXTO' },
                  { label: 'Marcação', value: 'MARCACAO' },
                  { label: 'Total', value: 'TOTAL' }
                ]}
                name='filtroIlegibilidade'
                onChange={(e) => setFiltroTipoIlegibilidade(e.target.value)}
              />
            </Grid>
          </Grid>

          <Grid item container>
            <Grid item sm={12} lg={12}>
              <CheckBox
                label='Somente cartões válidos (Ignora cartões descartados)'
                checked={filtroSomenteValidos}
                name='filtroSomenteValidos'
                onChange={(e) => setFiltroSomenteValidos(e.target.checked)}
              />
            </Grid>
          </Grid>

          <Grid item container>
            <Grid item sm={12} lg={12}>
              <CheckBox
                label='Somente cartões em processamento (Ignora cartões descartados e sem pendência)'
                checked={filtroSomenteCartoesEmProcessamento}
                name='filtroSomenteCartoesEmProcessamento'
                onChange={(e) => setFiltroSomenteCartoesEmProcessamento(e.target.checked)}
              />
            </Grid>
          </Grid>

          <Grid item container>
            <Grid item sm={12} lg={12}>
              <CheckBox
                label='Somente os cartões que tiveram divergencia de notas sem marcações digitadas (Ignora cartões descartados)'
                checked={filtroSomenteComDivergenciaNotaSemDigitador}
                name='filtroSomenteComDivergenciaNotaSemDigitador'
                onChange={(e) => setFiltroSomenteComDivergenciaNotaSemDigitador(e.target.checked)}
              />
            </Grid>
          </Grid>
        </Filters>
      }

      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Table
            columns={columns}
            tableData={cartoes}
            actions={actions}
            page={page}
            handlePage={handlePage}
            handleTotalPages={handleTotalPages}
            handleTotalElements={handleTotalElements}
            rowsPerPage={size}
            handleRowsPerPage={handleRowsPerPage}
            sort={sort}
            handleSort={handleSort}
            handleClearSort={handleClearSort}
            loading={loading}
            disableRowWhen={(obj) => obj.status === "DESCARTADO"}
            handleChecks={props.exibeCheckboxes ? handleMarcarCartoes : null}
            processo={processo}
          />
        </Grid>
      </Grid>

      {openDialogEdicao &&
        <Dialog
          maxWidth={"xl"}
          fullWidth={true}
          closeDialog={closeModalEdicao}
          openDialog={openDialogEdicao}
          title={isTratamentoNota ? `Tratamento de Nota do Cartão ${cartaoSelecionado?.codigo}` : `Editar Dados do Cartão ${cartaoSelecionado?.codigo}`}
          actions={[]}
          scroll="paper"
        >
          <Cartao
            processo={processo}
            origem={cartaoSelecionado && cartaoSelecionado.origem ? cartaoSelecionado.origem.id : undefined}
            codigo={cartaoSelecionado.codigo}
            id={cartaoSelecionado.id}
            tratamento={isTratamentoNota}
            onUpdate={(cartao) => {

              let cartoesTemp = cartoes.map(c => {

                if (c.id === cartao.data.id) {
                  return cartao.data;

                } else {
                  return c;
                }

              });

              setCartoes(cartoesTemp);
              setOpenDialogEdicao(false);

            }}
            onSaveStatus={(status) => {
              props.aoAtualizarStatusTratamentoNota(status, cartoes, setCartoes, filtroStatusTratamentoNota);
              setOpenDialogEdicao(false);
            }}
            onCancel={() => {
              setOpenDialogEdicao(false);
            }}
          />
        </Dialog>
      }

      {openModalVisualizarArquivo &&
        <Dialog
          maxWidth={"lg"}
          fullWidth={true}
          closeDialog={() => setOpenModalVisualizarArquivo(false)}
          openDialog={openModalVisualizarArquivo}
          title={`Cartão ${cartaoSelecionado.codigo}`}
          actions={[]}
        >
          {loadingDialog ?
            <Loading />
            :
            <>
              {cartaoSelecionado.ilegibilidade &&
                <ButtonPrimary style={{ float: 'right', marginTop: 8 }}
                  onClick={() => setOpenDialogCartaoArquivoLegivel(true)}
                  name="Marcar cartão como LEGÍVEL"
                />
              }

              <VisualizadorDeArquivo
                linkCorte={montarLinkCorte(cartaoSelecionado.codigo, cartaoSelecionado.numeroObjetoPostal, cartaoSelecionado.nomeArquivo)}
                ilegivel={cartaoSelecionado.ilegibilidade}
                cartaoId={cartaoSelecionado.id}
                aoMarcarComoIlegivel={() => {
                  EscolaService.cartaoIlegivel(processo, cartaoSelecionado.escola, cartaoSelecionado.id).then(resultado => {
                    setIlegivel(true);
                  });
                }}
                blob={blob}
              />
            </>
          }
        </Dialog>
      }

      {openDialogArquivo &&
        <Dialog
          maxWidth={"sm"}
          fullWidth={true}
          closeDialog={() => setOpenDialogArquivo(false)}
          openDialog={openDialogArquivo}
          title={"Enviar Cartão Resposta"}
          actions={[]}
        >
          <File handleUpload={(arquivo) => {
            const config = { headers: { 'content-type': 'multipart/form-data' } };

            const file = new FormData();
            file.append('nmArquivo', arquivo.name);
            file.append('tipoArquivo', arquivo.type);
            file.append('descricao', arquivo.description);
            file.append('arquivo', arquivo);

            EscolaService.uploadArquivoCartao(
              processo,
              cartaoSelecionado.escola,
              cartaoSelecionado.id,
              file,
              config).then(resultado => {
                buscarCartoes();
                setOpenDialogArquivo(false);
              }).catch(erro => {
                setOpenDialogArquivo(false);
                toastRef.current.show("error", "Não foi posível fazer upload do arquivo.");
              });
          }}
          />
        </Dialog>
      }

      {openDialogRestaurarCartao &&
        <DialogConfirm
          maxWidth={"sm"}
          id={{ id: cartaoSelecionado.id }}
          text={"Deseja realmente restaurar este cartão?"}
          close={() => setOpenDialogRestaurarCartao(false)}
          open={openDialogRestaurarCartao}
          title={"Importante"}
          handleConfirm={restaurarCartao}
        />
      }

      {openDialogAtualizarStatus &&
        <AtualizarStatusDialog
          id={cartaoSelecionado.id}
          processo={processo}
          escola={cartaoSelecionado.codigo ? cartaoSelecionado.codigo.substr(2, 8) : null}
          statusAtual={cartaoSelecionado.status}
          aberto={openDialogAtualizarStatus}
          aoFechar={() => {
            setOpenDialogAtualizarStatus(false)
          }
          }
          aoSalvar={() => {
            setOpenDialogAtualizarStatus(false);
            buscarCartoes();
          }}
        />
      }

      {openDialogTransferirCartoes &&
        <TransferirCartaoDialog
          processo={processo}
          listaDeCartoes={listaDeCartoesMarcados}
          aberto={openDialogTransferirCartoes}
          aoFechar={() => {
            setOpenDialogTransferirCartoes(false);

          }
          }
          aoSalvar={() => {
            setOpenDialogTransferirCartoes(false);

            if (props.aoTransferir)
              props.aoTransferir();
          }}
          toastReference={toastRef}
        />
      }

      {openDialogSubstituicao &&
        <Dialog
          maxWidth={"lg"}
          fullWidth={true}
          closeDialog={() => setOpenDialogSubstituicao(false)}
          openDialog={openDialogSubstituicao}
          title={`Substituir Cartão ${cartaoSelecionado.codigo}`}
          actions={[]}
        >
          <TextField
            label="Informe o novo código"
            value={novoCodigoCartao}
            onChange={(e) => setNovoCodigoCartao(e.target.value)}
          />
          <ButtonSave onClick={submitSubstituicaoCartao} />
        </Dialog>
      }

      {openDialogTratamentoNome &&
        <TratamentoNomeDialog
          handleSave={(e) => {
            props.aoAtualizarStatusTratamentoNome(e, cartoes, setCartoes, filtroStatusTratamentoNome);

            const indexAtual = cartoes.findIndex(c => c.id === e.data.id);
            const proximoCartao = cartoes[indexAtual + 1];

            if (proximoCartao) {
              console.log("Próximo cartão:", proximoCartao);
              setCartaoSelecionado(proximoCartao);
              setOpenDialogTratamentoNome(true);
            }
          }}
          processo={processo}
          id={cartaoSelecionado.id}
          handleClose={() => setOpenDialogTratamentoNome(false)}
          toastReference={toastRef}
          open={openDialogTratamentoNome}
        />
      }

      {openDialogTratamentoDataNascimento &&
        <TratamentoDataNascimentoDialog
          handleSave={(e) => {
            props.aoAtualizarStatusTratamentoDataNascimento(e, cartoes, setCartoes, filtroStatusTratamentoDataNascimento);
          }}
          processo={processo}
          id={cartaoSelecionado.id}
          handleClose={() => setOpenDialogTratamentoDataNascimento(false)}
          toastReference={toastRef}
          open={openDialogTratamentoDataNascimento}
        />
      }

      {openDialogTratamentoCPF &&
        <TratamentoCPFDialog
          handleSave={(e) => {
            props.aoAtualizarStatusTratamentoCPF(e, cartoes, setCartoes, filtroStatusTratamentoCPF);
          }}
          processo={processo}
          id={cartaoSelecionado.id}
          handleClose={() => setOpenDialogTratamentoCPF(false)}
          toastReference={toastRef}
          open={openDialogTratamentoCPF}
        />
      }

      {openDialogListagemTratamentos &&
        <ListagemTratamentosDialog
          processo={processo}
          id={cartaoSelecionado.id}
          handleClose={() => setOpenDialogListagemTratamentos(false)}
          toastReference={toastRef}
          open={openDialogListagemTratamentos}
        />
      }

      {openDialogDescartarCartao &&
        <DescartarCartaoDialog
          mensagemCustomizada={props.mensagemInformativaAoDescartarCartao}
          aoConfirmar={props.aoDescartarCartao}
          aoFechar={() => setOpenDialogDescartarCartao(false)}
          aberto={openDialogDescartarCartao}
          processo={processo}
          motivosDescarteDisponiveis={props.motivosDescarteDisponiveis ? props.motivosDescarteDisponiveis : []}
          id={cartaoSelecionado.id}
          codigo={cartaoSelecionado.codigo}
        />
      }

      {openDialogCartaoArquivoLegivel &&
        <DialogCartaoLegivel
          maxWidth={"sm"}
          id={cartaoSelecionado.id}
          text={`Deseja realmente marcar este cartão como legível ?`}
          close={() => setOpenDialogCartaoArquivoLegivel(false)}
          open={openDialogCartaoArquivoLegivel}
          title={cartaoSelecionado.codigo}
          motivoIlegibilidade={cartaoSelecionado.ilegibilidade}
          handleConfirm={handleMarcarCartaoLegivel}
        />
      }


      {openDialogMoverCartaoParaCaixaDaEscola &&
        <DialogConfirm
          maxWidth={"lg"}
          id={cartaoSelecionado.id}
          text={`Deseja realmente MOVER este Cartão da Caixa #${cartaoSelecionado.caixa} para a mesma Caixa da Escola (#${cartaoSelecionado.caixaEscola}) ?`}
          close={() => setOpenDialogMoverCartaoParaCaixaDaEscola(false)}
          open={openDialogMoverCartaoParaCaixaDaEscola}
          title={"Mover Cartão para mesma Caixa da Escola"}
          handleConfirm={handleMoverCartaoParaCaixaDaEscola}
        />
      }

      {(props.permiteDigitarCartao === undefined || props.permiteDigitarCartao === true) &&
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <ButtonPrimary
              onClick={redirectDigitarCartoes}
              name="Digitar Novo Cartão"
              startIcon={<AddIcon />}
            />
          </Grid>
        </Grid>
      }

      {props.permiteTranferenciaEmLoteDeCartoes === true &&
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <ButtonPrimary
              onClick={abrirModalTransferirCartao}
              name="Transferir Cartões em Lote"
              startIcon={<AddIcon />}
            />
          </Grid>
        </Grid>
      }
    </>
  );
});

export default CartoesTableViewV2;